import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'stripe-connect-express-create-modal',
    templateUrl: './stripe-connect-express-create-modal.component.html',
    styleUrl: './stripe-connect-express-create-modal.component.scss',
    standalone: false
})
export class StripeConnectExpressCreateModalComponent {
  dialogRef = inject(MatDialogRef<StripeConnectExpressCreateModalComponent>);

  public isIndividual: boolean = true;
  public businessDetailsForm = new FormGroup({
    golfTechId: new FormControl(),
    refreshUrl: new FormControl(),
    returnUrl: new FormControl(),
    emailAddress: new FormControl(),
    name: new FormControl(),
    isIndividual: new FormControl(this.isIndividual),
    businessDetails: new FormGroup({
      businessName: new FormControl('', {
        validators: Validators.required
      }),
      website: new FormControl('',{
        validators: Validators.required
      }),
    })
  });

  public disableClose: boolean = false;

  onClose() {
    if(this.isIndividual){
      this.businessDetailsForm.get('businessDetails').get('businessName').patchValue(null);
      this.businessDetailsForm.get('businessDetails').get('website').patchValue(null);
      this.dialogRef.close(this.businessDetailsForm.value);
    }else{
      if(this.businessDetailsForm.valid){
        this.dialogRef.close(this.businessDetailsForm.value);
      }
    }
  }

}
